import React from "react";
import DeadLift from "components/animation/hero/DeadLift";
import ArrowIcon from "assets/images/svg/arrow.svg";
import DeadLiftImg from "assets/images/deadlift.jpg";

function AboutElevated() {
  return (
    <div className="container-fluid about-elevated-iron-bg position-relative z-index-1 ">
      {/* <img className="background-svg py-md-0" src={DeadLiftImg} alt="" /> */}
      <div className="container py-md-0 py-5 ">
        <div className="row hw-100">
          <div className="col-lg-6 col-md-6 col-sm-6 my-auto py-2">
            <div className="about-elevated-content text-md-start text-center pb-3">
              <h2 className="fs-80 hc fw-700 l-h-0-9 ">ABOUT</h2>

              <p className="fs-64 l-h-0-9 custom-color-blue fw-300">
                ELEVATED IRON
              </p>
              <p className="text-white my-md-4 my-2 fw-300 l-h-1-3 fs-18">
                Borem ipsum dolor sit amet, consectetur adipiscing elit. ipsum
                dolor sit amet, consectetur adipiscing elit dolor Borem amet,
                consectetur adipiscing elit
              </p>
              <button className="btn-custom fs-18 mt-2">
                Register Now <img src={ArrowIcon} alt="Arrow Icon" />
              </button>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 py-2 d-flex align-items-center justify-content-md-end justify-content-center">
            <DeadLift />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutElevated;
